export const COPY_TEXT_TIMEOUT = 2000;
